import LeadKanbanColumn from '../LeadKanbanColumn/LeadKanbanColumn';
import './LeadKanbanBoard.css';

const COLUMNS = [
  { status: 'NEW',               label: 'Just Discovered', color: '#8aaab5' },
  { status: 'CALLING',           label: 'Already Talking',  color: '#0090c1' },
  { status: 'ENGAGED',           label: 'Actively Engaged', color: '#f0a500' },
  { status: 'MEETING_SCHEDULED', label: 'Meeting Lined Up', color: '#1aaa6e' },
  { status: 'QUALIFIED',         label: 'Ready to Invest',  color: '#004358' },
];

function isOverdue(lead) {
  const now = Date.now();
  if (lead.next_follow_up_at && new Date(lead.next_follow_up_at) < now) return true;
  if (!lead.last_contacted_at && (now - new Date(lead.created_at)) / 86400000 > 3) return true;
  if (lead.last_contacted_at && !lead.next_follow_up_at &&
    (now - new Date(lead.last_contacted_at)) / 86400000 > 3) return true;
  return false;
}

export default function LeadKanbanBoard({ leads, search, onCardClick, onStatusChange, quickFilter }) {
  const filtered = leads.filter(lead => {
    if (quickFilter === 'overdue' && !isOverdue(lead)) return false;
    if (quickFilter === 'hot' && (lead.hot_score || 0) <= 70) return false;
    if (!search) return true;
    const q = search.toLowerCase();
    return (lead.name || '').toLowerCase().includes(q) ||
           (lead.phone || '').toLowerCase().includes(q);
  });

  const totalActive = filtered.length;

  return (
    <div className="lkb__board">
      {COLUMNS.map(col => {
        const colLeads = filtered.filter(l => l.status === col.status);
        return (
          <LeadKanbanColumn
            key={col.status}
            column={col}
            leads={colLeads}
            totalActive={totalActive}
            onCardClick={onCardClick}
            onDrop={onStatusChange}
          />
        );
      })}
    </div>
  );
}
